import { useState } from 'react';
import Header from './components/Header';
import VideoHero from './components/VideoHero';
import WorkGrid from './components/WorkGrid';
import QuantumRevealGate from './components/QuantumRevealGate';
import WhatWeDoPage from './components/WhatWeDoPage';
import AboutPage from './components/AboutPage';
import ArticlesPage from './components/ArticlesPage';
import ContactPage from './components/ContactPage';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [animationStage, setAnimationStage] = useState('entering');
  
  // 1. NEW STATE: Tracks if the QuantumRevealGate is complete
  const [isSiteLoaded, setIsSiteLoaded] = useState(false); 

  // 2. NEW HANDLER: Function called by QuantumRevealGate when it's done
  const handleGateComplete = () => {
      setIsSiteLoaded(true);
  };
  
  // Navigation handler for footer clicks
  const handleNavigation = (page) => {
    console.log('Navigating to:', page);
    
    // Trigger exit animation if we're already on a page
    if (currentPage !== 'home') {
      setAnimationStage('exiting');
      setTimeout(() => {
        setCurrentPage(page);
        setAnimationStage('entering');
        setTimeout(() => setAnimationStage('visible'), 100);
      }, 500);
    } else {
      setCurrentPage(page);
      setAnimationStage('entering');
      setTimeout(() => setAnimationStage('visible'), 100);
    }
  };

  const handleClosePage = () => {
    setAnimationStage('exiting');
    setTimeout(() => {
      setCurrentPage('home');
      setAnimationStage('entering');
      setTimeout(() => setAnimationStage('visible'), 100);
    }, 500);
  };

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'what-we-do':
        return (
          <WhatWeDoPage 
            onClose={handleClosePage} 
            animationStage={animationStage}
            onNavigate={handleNavigation}
          />
        );
      case 'about':
        return (
          <AboutPage 
            onClose={handleClosePage} 
            animationStage={animationStage}
            onNavigate={handleNavigation}
          />
        );
      case 'articles':
        return (
          <ArticlesPage 
            onClose={handleClosePage} 
            animationStage={animationStage}
            onNavigate={handleNavigation}
          />
        );
      case 'contact':
        return (
          <ContactPage 
            onClose={handleClosePage} 
            animationStage={animationStage}
            onNavigate={handleNavigation}
          />
        );
      case 'privacy':
        // ...
        return <div className="min-h-screen bg-slate-950 text-white p-8">Privacy Policy Page</div>;
      case 'terms':
        // ...
        return <div className="min-h-screen bg-slate-950 text-white p-8">Terms & Conditions Page</div>;
      case 'cookies':
        // ...
        return <div className="min-h-screen bg-slate-950 text-white p-8">Cookies Policy Page</div>;
      default:
        return (
          <>
            <VideoHero />
            <WorkGrid onNavigate={handleNavigation} />
          </>
        );
    }
  };

  return (
    <>
      {/* 3. CONDITIONAL RENDERING: Render the Gate ONLY if isSiteLoaded is false */}
      {!isSiteLoaded && (
          <QuantumRevealGate onRevealComplete={handleGateComplete} />
      )}

      {/* 4. Render the App content ONLY if isSiteLoaded is true. 
             Use a class to hide it until it's ready to prevent initial content flash. 
             If isSiteLoaded is true, the content is rendered.
      */}
      <div className={`App bg-metalab-black min-h-screen flex flex-col ${isSiteLoaded ? '' : 'hidden'}`}>
        <Header onNavigate={handleNavigation} />
        <main className="flex-1">
          {renderCurrentPage()}
        </main>
      </div>
    </>
  );
}

export default App;